<template>
  <div class="login-container">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-6">
          <div class="card mt-5">
            <div class="card-header text-center">
              <h2>Log in - ISACI</h2>
            </div>
            <div class="card-body">
              <form @submit.prevent="handleLogin">
                <div class="form-group">
                  <label for="email">Email</label>
                  <input 
                    type="email" 
                    class="form-control" 
                    id="email" 
                    v-model="form.email"
                    required
                  >
                </div>
                <div class="form-group">
                  <label for="password">Password</label>
                  <input 
                    type="password" 
                    class="form-control" 
                    id="password" 
                    v-model="form.password"
                    required
                  >
                </div>
                <div class="form-group form-check">
                  <input 
                    type="checkbox" 
                    class="form-check-input" 
                    id="rememberMe"
                    v-model="form.rememberMe"
                  >
                  <label class="form-check-label" for="rememberMe">
                    Remember me?
                  </label>
                </div>
                <div class="form-group">
                  <button type="submit" class="btn btn-primary btn-block" :disabled="loading">
                    {{ loading ? 'Logging in...' : 'Log in' }}
                  </button>
                </div>
                <div class="text-center">
                  <router-link to="/forgot-password">Forgot your password?</router-link>
                </div>
                <div class="text-center mt-3">
                  <router-link to="/create-account">Create New Account</router-link>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { apiService } from '@/config/api'

export default {
  name: 'Login',
  data() {
    return {
      form: {
        email: '',
        password: '',
        rememberMe: false
      },
      loading: false
    }
  },
  mounted() {
    // 检查是否有保存的登录信息
    const savedEmail = localStorage.getItem('savedEmail')
    const savedPassword = localStorage.getItem('savedPassword')
    const rememberMe = localStorage.getItem('rememberMe') === 'true'
    
    if (rememberMe && savedEmail && savedPassword) {
      this.form.email = savedEmail
      this.form.password = savedPassword
      this.form.rememberMe = true
    }
  },
  methods: {
    async handleLogin() {
      // 表单验证
      if (!this.form.email || !this.form.password) {
        alert('Please fill in the email and password')
        return
      }

      this.loading = true
      try {
        const response = await apiService.auth.login({
          account: this.form.email,
          password: this.form.password
        })

        
        if (response.data.code==1) {
          // 登录成功
          if (response.data.data) {
            localStorage.setItem('authToken', response.data.data.userinfo.token)
            // localStorage.setItem('userLevel', 1)
           
          }
          
          // 记住我功能
          if (this.form.rememberMe) {
            localStorage.setItem('savedEmail', this.form.email)
            localStorage.setItem('savedPassword', this.form.password)
            localStorage.setItem('rememberMe', 'true')
          } else {
            localStorage.removeItem('savedEmail')
            localStorage.removeItem('savedPassword')
            localStorage.removeItem('rememberMe')
          }
          
          // 跳转到首页
          // this.$router.push('/MettingIndex')
          this.$router.push('/Announcements')
        } else {
          alert(response.data.message || 'Login failed, please check your email and password')
        }
      } catch (error) {
        
        if (error.response) {
          // 服务器返回错误状态码
          switch (error.response.status) {
            case 400:
              alert('Request parameter error')
              break
            case 401:
              alert('Email or password error')
              break
            default:
              alert('Login failed, please try again later')
          }
        } else if (error.request) {
          // 网络错误
          alert('Network connection failed, please check your network')
        } else {
          // 其他错误
          alert('Login failed, please try again later')
        }
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.login-container {
  min-height: 100vh;
  background-color: #f8f9fa;
  padding: 20px 0;
}

.card {
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.card-header {
  /* background-color: #007bff;
   */
   background-color: #3498DB;
  color: white;
}


.btn-block {
  width: 100%;
  background-color: #3498DB;
}

.form-group {
  margin-bottom: 1rem;
}
</style> 